import { render, staticRenderFns } from "./complete_demo_form.vue?vue&type=template&id=70d76efe&"
import script from "./complete_demo_form.vue?vue&type=script&lang=js&"
export * from "./complete_demo_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports